import { AppBar, Box, Grid, Typography } from "@material-ui/core";
import React from "react";
// import { makeStyles } from "@material-ui/core/styles";

import { makeStyles } from "@material-ui/core/styles";
// import AiOutlineCloseCircle from "react-icons";\
import { useNavigate } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
    main: {
        background: "white",
        // height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        maxHeight: "max-content",
        scrollBehavior: "smooth",
        fontFamily: "Times New Roman !important",
    },

    appBar: {
        height: 100,
        background: "#3F8DF7",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        boxShadow: "none !important",
        alignItems: "center",
        position: "sticky",
        top: 0,
        // padding: "5px"
    },
    logo: {
        width: "90px",
        // height: "65px",
    },
    content: {
        width: "900px",
        maxWidth: "80vw",
        padding: "2rem",
        paddingTop: "2rem",
        // background: "red",
        display: "flex",
        justifyContent: "start",
        fontFamily: "Times New Roman !important",
    },
    title: {
        color: "black",
        fontFamily: "Times New Roman !important",
        fontWeight: "bold",
    },
    section: {
        marginBottom: "2rem !important",
        fontFamily: "Times New Roman !important",
    },
    contentHeading: {
        marginBottom: "1rem",
        marginTop: "1rem",
        fontFamily: "Times New Roman !important",
        fontWeight: "600",
    },
    contentText: {
        marginBottom: "0.5rem",
        textAlign: "justify !important",
        fontFamily: "Times New Roman !important",
    },
    font: {
        fontFamily: "Times New Roman !important",
    },
    close: {
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        right: "1rem",
        fontSize: "1.5rem",
        cursor: "pointer",
        color: "white",
    },
}));
const PrivacyPolicy = () => {
    const classes = useStyles();
    const nav = useNavigate();
    return (
        <div className={classes.main}>
            <div className={classes.appBar}>
                <img src="/CoitorLogo.png" alt="Logo" className={classes.logo} />
            </div>
            <center className={classes.content}>
                <div>
                    <div
                        className={classes.section}
                        style={{ fontFamily: "Times New Roman" }}
                    >
                        <Typography variant="h4" align="left" className={classes.title}>
                            {" "}
                            Privacy Policy
                        </Typography>
                        <Typography
                            align="left"
                            variant="subtitle1"
                            className={classes.contentText}
                        >
                            Last updated: [17/10/2023]
                        </Typography>
                    </div>
                    <div className={classes.section}>
                        <Typography
                            variant="h5"
                            align="left"
                            className={classes.contentHeading}
                        >
                            {" "}
                            Introduction
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            style={{
                                fontSize: "1.2rem",
                            }}
                            // align="left"
                            className={classes.contentText}
                        >
                            This Privacy Policy explains how Coitor IT Tech collects, uses,
                            and shares personal information when you use our application
                            Coitor Social Engagement. We are committed to protecting your
                            privacy and ensuring the security of your personal information.
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            style={{
                                fontSize: "1.2rem",
                            }}
                            align="left"
                            className={classes.contentText}
                        >
                            By using our application, you consent to the practices described
                            in this Privacy Policy. Please read this Policy carefully to
                            understand our practices regarding your personal information.
                        </Typography>
                        <br></br>
                        {/* <br></br> */}
                        <Typography
                            className={classes.contentHeading}
                            variant="h5"
                            align="left"
                        >
                            Information We Collect{" "}
                        </Typography>
                        <ul>
                            <li>
                                <Typography
                                    align="left"
                                    className={classes.contentText}
                                    style={{ paddingLeft: "2rem" }}
                                >
                                    <span
                                        style={{
                                            fontSize: "1.2rem",
                                            // fontWeight: "500 !important",
                                        }}
                                    >
                                        Information You Provide: &#160;
                                    </span>
                                    <span
                                        variant="subtitle1"
                                        style={{
                                            fontSize: "1.2rem",
                                        }}
                                    >
                                        We may collect information that you provide directly to us,
                                        including but not limited to your name, contact information,
                                        and any content you post or share on our application.
                                    </span>
                                </Typography>
                            </li>
                            <li>
                                <Typography
                                    align="left"
                                    className={classes.contentText}
                                    style={{ paddingLeft: "2rem" }}
                                >
                                    <span
                                        style={{
                                            fontSize: "1.2rem",
                                            fontWeight: "500",
                                        }}
                                    >
                                        Social Media Data: &#160;
                                    </span>
                                    <span
                                        variant="subtitle1"
                                        style={{
                                            fontSize: "1.2rem",
                                        }}
                                    >
                                        When you interact with our application by tagging and
                                        sharing your in-store experiences on social media platforms
                                        such as Facebook and Instagram, we may collect data made
                                        available by those platforms through their APIs. This data
                                        may include your social media handle, posts, and related
                                        information.
                                    </span>
                                </Typography>
                            </li>
                        </ul>
                    </div>
                    {/* <br></br> */}
                    <div className={classes.section}>
                        <Typography
                            variant="h5"
                            align="left"
                            className={classes.contentHeading}
                        >
                            How We Use Your Information{" "}
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            style={{
                                fontSize: "1.2rem",
                            }}
                            align="left"
                            className={classes.contentText}
                        >
                            We use the collected information for the following purposes:
                        </Typography>

                        <ul>
                            <li>
                                <Typography
                                    align="left"
                                    className={classes.contentText}
                                    style={{ paddingLeft: "2rem" }}
                                >
                                    <span
                                        style={{
                                            fontSize: "1.2rem",
                                            fontWeight: "500",
                                        }}
                                    >
                                        Improving In-Store Experience: &#160;
                                    </span>
                                    <span
                                        variant="subtitle1"
                                        style={{
                                            fontSize: "1.2rem",
                                        }}
                                    >
                                        We use your information to enhance your in-store experience
                                        by sharing your social media posts updates & reviews in
                                        real-time on our application.
                                    </span>
                                </Typography>
                            </li>
                            <li>
                                <Typography
                                    align="left"
                                    className={classes.contentText}
                                    style={{ paddingLeft: "2rem" }}
                                >
                                    <span
                                        style={{
                                            fontSize: "1.2rem",
                                            fontWeight: "500",
                                        }}
                                    >
                                        Communication: &#160;
                                    </span>
                                    <span
                                        variant="subtitle1"
                                        style={{
                                            fontSize: "1.2rem",
                                        }}
                                    >
                                        We may use your contact information to send you updates,
                                        marketing communications, and information related to our
                                        services.
                                    </span>
                                </Typography>
                            </li>
                            <li>
                                <Typography
                                    align="left"
                                    className={classes.contentText}
                                    style={{ paddingLeft: "2rem" }}
                                >
                                    <span
                                        style={{
                                            fontSize: "1.2rem",
                                            fontWeight: "500",
                                        }}
                                    >
                                        Analytics: &#160;
                                    </span>
                                    <span
                                        variant="subtitle1"
                                        style={{
                                            fontSize: "1.2rem",
                                        }}
                                    >
                                        We may use the information for statistical and analytical
                                        purposes, helping us understand how our application is used,
                                        how to improve it, and to generate reports.
                                    </span>
                                </Typography>
                            </li>
                        </ul>
                    </div>
                    <div className={classes.section}>
                        <Typography
                            variant="h5"
                            align="left"
                            className={classes.contentHeading}
                        >
                            Sharing Your Information
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            style={{
                                fontSize: "1.2rem",
                            }}
                            align="left"
                            className={classes.contentText}
                        >
                            We may share your personal information with third parties in the
                            following situations:{" "}
                        </Typography>
                        <ul>
                            <li>
                                <Typography
                                    align="left"
                                    className={classes.contentText}
                                    style={{ paddingLeft: "2rem" }}
                                >
                                    <span
                                        style={{
                                            fontSize: "1.2rem",
                                            fontWeight: "500",
                                        }}
                                    >
                                        With Your Consent: &#160;
                                    </span>
                                    <span
                                        variant="subtitle1"
                                        style={{
                                            fontSize: "1.2rem",
                                        }}
                                    >
                                        We may share your information with third parties when you
                                        give us explicit consent to do so.
                                    </span>
                                </Typography>
                            </li>
                            <li>
                                <Typography
                                    align="left"
                                    className={classes.contentText}
                                    style={{ paddingLeft: "2rem" }}
                                >
                                    <span
                                        style={{
                                            fontSize: "1.2rem",
                                            fontWeight: "500",
                                        }}
                                    >
                                        Service Providers: &#160;
                                    </span>
                                    <span
                                        variant="subtitle1"
                                        style={{
                                            fontSize: "1.2rem",
                                        }}
                                    >
                                        We may share your information with trusted third-party
                                        service providers who help us operate and maintain our
                                        application.
                                    </span>
                                </Typography>
                            </li>
                            <li>
                                <Typography
                                    align="left"
                                    className={classes.contentText}
                                    style={{ paddingLeft: "2rem" }}
                                >
                                    <span
                                        style={{
                                            fontSize: "1.2rem",
                                            fontWeight: "500",
                                        }}
                                    >
                                        Legal Requirements: &#160;
                                    </span>
                                    <span
                                        variant="subtitle1"
                                        style={{
                                            fontSize: "1.2rem",
                                        }}
                                    >
                                        We may disclose your information to comply with legal
                                        obligations, respond to requests from law enforcement, or
                                        protect our rights and safety.
                                    </span>
                                </Typography>
                            </li>
                        </ul>
                    </div>
                    <div className={classes.section}>
                        <Typography
                            variant="h5"
                            align="left"
                            className={classes.contentHeading}
                        >
                            User Preferences
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            style={{
                                fontSize: "1.2rem",
                            }}
                            align="left"
                            className={classes.contentText}
                        >
                            You have the following choices regarding your personal
                            information:
                        </Typography>
                        <ul>
                            <li>
                                <Typography
                                    align="left"
                                    className={classes.contentText}
                                    style={{ paddingLeft: "2rem" }}
                                >
                                    <span
                                        style={{
                                            fontSize: "1.2rem",
                                            fontWeight: "500",
                                        }}
                                    >
                                        Access, Correct, or Delete: &#160;
                                    </span>
                                    <span
                                        variant="subtitle1"
                                        style={{
                                            fontSize: "1.2rem",
                                        }}
                                    >
                                        You can access, correct, or delete your personal information
                                        by contacting us at &#160;
                                        <a href="https://info@coitor.com" target="_blank">
                                            info@coitor.com
                                        </a>
                                    </span>
                                </Typography>
                            </li>
                            <li>
                                <Typography
                                    align="left"
                                    className={classes.contentText}
                                    style={{ paddingLeft: "2rem" }}
                                >
                                    <span
                                        style={{
                                            fontSize: "1.2rem",
                                            fontWeight: "500",
                                        }}
                                    >
                                        Marketing Communications:&#160;
                                    </span>
                                    <span
                                        variant="subtitle1"
                                        style={{
                                            fontSize: "1.2rem",
                                        }}
                                    >
                                        You can opt out of receiving marketing communications from
                                        us by following the unsubscribe instructions included in our
                                        messages.
                                    </span>
                                </Typography>
                            </li>
                            <li>
                                <Typography
                                    align="left"
                                    className={classes.contentText}
                                    style={{ paddingLeft: "2rem" }}
                                >
                                    <span
                                        style={{
                                            fontSize: "1.2rem",
                                            fontWeight: "500",
                                        }}
                                    >
                                        Legal Requirements: &#160;
                                    </span>
                                    <span
                                        variant="subtitle1"
                                        style={{
                                            fontSize: "1.2rem",
                                        }}
                                    >
                                        We may disclose your information to comply with legal
                                        obligations, respond to requests from law enforcement, or
                                        protect our rights and safety.
                                    </span>
                                </Typography>
                            </li>
                        </ul>
                    </div>
                    <div className={classes.section}>
                        <Typography
                            variant="h5"
                            align="left"
                            className={classes.contentHeading}
                        >
                            Security
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            style={{
                                fontSize: "1.2rem",
                            }}
                            align="left"
                            className={classes.contentText}
                        >
                            We take reasonable measures to protect your personal information
                            from unauthorized access, disclosure, alteration, or destruction.
                        </Typography>
                    </div>
                    <div className={classes.section}>
                        <Typography
                            variant="h5"
                            align="left"
                            className={classes.contentHeading}
                        >
                            Changes to this Privacy Policy
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            style={{
                                fontSize: "1.2rem",
                            }}
                            align="left"
                            className={classes.contentText}
                        >
                            We may update this Privacy Policy from time to time. The most
                            recent version of the Policy will be posted on our website and
                            will indicate the date of the latest revision.
                        </Typography>
                    </div>
                    <div className={classes.section}>
                        <Typography
                            variant="h5"
                            align="left"
                            className={classes.contentHeading}
                        >
                            Contact Us
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            style={{
                                fontSize: "1.2rem",
                            }}
                            align="left"
                            className={classes.contentText}
                        >
                            If you have any questions, concerns, or requests regarding this
                            Privacy Policy or your personal information, please contact us at
                            &#160;
                            <a href="https://info@coitor.com" target="_blank">
                                info@coitor.com
                            </a>
                        </Typography>
                    </div>
                </div>
            </center>

            {/* </div> */}
        </div>
    );
};

export default PrivacyPolicy;
